import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
  title:"",
  insights: false,
  dashboard: false,
  industries: [],
  regions: [],
  countries: [],
  addressedToEmail:[],
  B2B: {},
  B2C: {},
  B2G: {},
  HNWI: {},
  HLC: {},
  otherSpecifics:null,
  approximateCost:0,
  totalSampleSize:0,
  statusCode:"",
}



export const sliceName = "EndClient"



export const EndClientSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    handleEndClientData:(state,action)=>{
      return {...state,...action.payload};
    },
    handleBackgroundAndObjective: (state, action) => {
      return { ...state, backgroundAndObjective: action.payload }
    },
    handleInsights: (state,action) => {
      return { ...state, insights: action.payload }
    },
    handleDashboard: (state,action) => {
      return { ...state, dashboard: action.payload }
    },
    handleSpecifics: (state, action) => {
      const specifics  = action.payload;
      return {...state,otherSpecifics:specifics}
    },
    handleIndustries: (state, action) => {
      if (state.industries.includes(action.payload)) {
        return { ...state, industries: state.industries.filter(industry => industry !== action.payload) }
      }
      else {
        return { ...state, industries: [...state.industries, action.payload] }
      }
    },
    handleRegions: (state, action) => {
      if (state.regions.includes(action.payload)) {
        return { ...state, regions: state.regions.filter(industry => industry !== action.payload) }
      }
      else {
        return { ...state, regions: [...state.regions, action.payload] }
      }
    },
    handleCountries: (state, action) => {
      if (state.countries.includes(action.payload)) {
        return { ...state, countries: state.countries.filter(industry => industry !== action.payload) }
      }
      else {
        return { ...state, countries: [...state.countries, action.payload] }
      }
    },
    handleIndustrySpecificData: (state, action) => {
      const { isChecked, title, industry } = action.payload;
      if (isChecked) {
        return { ...state, [industry]: { ...state[industry], [title]: 0 } }
      }
      else {
        delete state[industry][title]
      }
    },
    handleIndustrySpecificValues: (state, action) => {
      const { value, industry, title } = action.payload;
      return { ...state, [industry]: { ...state[industry], [title]: value } }
    },
    handleResetIndustry: (state, action) => {
      const { industry } = action.payload
      return { ...state, [industry]: {} }
    },
    handleSampleSize:(state,action)=>{
      const totalSampleSize= action.payload;
      return {...state,totalSampleSize:totalSampleSize}
    },
    handleApproximateCost:(state,action)=>{
      const approximateCost= action.payload;
      return {...state,approximateCost:approximateCost}
    },
    handleStatusCode:(state,action)=>{
      const statusCode=action.payload;
      return {...state,statusCode:statusCode}
    },
    handleAddressedEmail:(state,action)=>{
      const emails=action.payload;   
      return {...state,addressedToEmail:emails}
     },
     handleEndClientReset:(state)=>{
      return initialState;
     }
  }
})

export const EndClientDataState = state => state[sliceName]


// Action creators are generated for each case reducer function
export const { handleIndustries,handleApproximateCost,handleSampleSize,handleEndClientData,handleAddressedEmail, handleIndustrySpecificData, handleRegions,handleStatusCode, handleCountries, handleIndustrySpecificValues, handleBackgroundAndObjective,handleSpecifics, handleInsights, handleDashboard, handleResetIndustry,handleEndClientReset } = EndClientSlice.actions

export default EndClientSlice.reducer